import { z } from 'zod';

export const STAFF_PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const STAFF_PHOTO_MAX_COUNT = 4;
export const staffPhotoUploadId = z.string().regex(/^[A-Za-z0-9_-]{1,100}$/);
export const staffPhotoPostSchema = z
  .object({
    clientMutationId: staffPhotoUploadId,
    body: z.string().trim().min(1).max(4000),
    photoIds: z
      .array(z.string().regex(/^[0-9A-Z]{26}$/))
      .min(1)
      .max(STAFF_PHOTO_MAX_COUNT),
  })
  .refine((data) => new Set(data.photoIds).size === data.photoIds.length, { message: 'Choose each photo once.' });

export const staffPhotoCopy = {
  en: {
    title: 'Staff photos',
    back: 'Back to Staff',
    message: 'Message',
    choose: 'Choose photos',
    limits: 'Up to 4 JPEG or PNG photos, 5 MB each. Photos and your draft stay here while this page is open.',
    publish: 'Publish photo post',
    retry: 'Retry the same post',
    refresh: 'Refresh',
    remove: 'Remove photo',
    loading: 'Loading staff photos…',
    empty: 'No photo posts yet.',
    former: 'Former team member',
    disabled: 'Staff photos are not available at this location yet.',
    error: 'The request could not be completed. Your draft is retained.',
    uncertain: 'The result could not be confirmed. Retry the same post before editing.',
    saved: 'Photo post published.',
    invalid: 'Choose up to 4 JPEG or PNG photos, 5 MB each.',
    unavailable: 'Photo unavailable. Refresh to try again.',
    blocked: 'Staff photos require Pro or Business and staff access.',
    reading: 'Photos are visible to active staff at this location.',
    unused: 'Unused uploads',
    discard: 'Discard unused upload',
    discarded: 'Unused upload discarded.',
    missing: 'A photo is no longer available. Remove it and choose it again. Your message is retained.',
    more: 'Load more',
  },
  es: {
    title: 'Fotos del personal',
    back: 'Volver a Personal',
    message: 'Mensaje',
    choose: 'Elegir fotos',
    limits:
      'Hasta 4 fotos JPEG o PNG de 5 MB cada una. Las fotos y su borrador permanecen aquí mientras esta página esté abierta.',
    publish: 'Publicar fotos',
    retry: 'Reintentar la misma publicación',
    refresh: 'Actualizar',
    remove: 'Quitar foto',
    loading: 'Cargando las fotos del personal…',
    empty: 'Todavía no hay publicaciones con fotos.',
    former: 'Antiguo miembro del equipo',
    disabled: 'Las fotos del personal aún no están disponibles en esta ubicación.',
    error: 'No se pudo completar la solicitud. Se conserva su borrador.',
    uncertain: 'No se pudo confirmar el resultado. Reintente la misma publicación antes de editarla.',
    saved: 'Publicación con fotos guardada.',
    invalid: 'Elija hasta 4 fotos JPEG o PNG de 5 MB cada una.',
    unavailable: 'Foto no disponible. Actualice para intentarlo de nuevo.',
    blocked: 'Las fotos del personal requieren Pro o Business y acceso del personal.',
    reading: 'Las fotos son visibles para el personal activo de esta ubicación.',
    unused: 'Archivos sin publicar',
    discard: 'Descartar archivo sin publicar',
    discarded: 'Archivo sin publicar descartado.',
    missing: 'Una foto ya no está disponible. Quítela y elíjala de nuevo. Se conserva su mensaje.',
    more: 'Cargar más',
  },
} as const;
